import { Input } from '@storeblocks/input';
import { type FC } from 'react';
import styled from 'styled-components';

import { NumericFormatProps } from '../types/NumericFormatProps';

export const AmountBaseInput: FC<NumericFormatProps> = (props) => {
  return (
    <StyledInput
      id={props.id}
      value={props.value}
      disabled={props.disabled}
      onChange={props.onChange}
      onBlur={props.onBlur}
      alert={{
        messageType: props.alert?.messageType === 'error' ? 'error' : undefined,
        message: props.alert?.message,
      }}
      hint={{ text: props.hint?.text }}
      fluid
      {...props}
      suffix={{
        content: props.$customSuffix ? props.$customSuffix : '',
        props: {
          id: `${props.id}-input-suffix`,
        },
      }}
    />
  );
};

const StyledInput = styled(Input)`
  & input {
    text-align: right;
  }

  min-width: 184px;
`;
